import { ExpandedContent, Separator, EmptyState } from "../../Compartilhado/styles";
import { IItemHistoricoPlano } from "../../../../types";
import BlocoPrincipal from "../../Compartilhado/Blocos/BlocoPrincipal";
import { CampoValor } from "../../Compartilhado/Blocos/BlocoPrincipal";
import { formatServicoColuna } from "../../../../../../../utils/servicoMapperPlanos";

interface ExpandedContentProps {
  item: IItemHistoricoPlano;
  isExpanded?: boolean;
}

function formatarValorMonetario(valor: any): string {
  if (valor === null || valor === undefined) return '—';
  if (typeof valor === 'number') {
    return `R$ ${valor.toFixed(2).replace('.', ',')}`;
  }
  return String(valor);
}

function mapearDadosServicoAdicionado(payload: any): CampoValor[] {
  if (!payload) return [];

  const campos: CampoValor[] = [];

  if (payload.id_servico != null) {
    campos.push({ campo: 'ID Serviço', valor: String(payload.id_servico) });
  }
  if (payload.modalidade) {
    campos.push({ campo: 'Modalidade', valor: payload.modalidade });
  }
  if (payload.profissional) {
    campos.push({ campo: 'Profissional', valor: payload.profissional });
  }
  if (payload.modo_precificacao) {
    campos.push({ 
      campo: 'Modo de Precificação', 
      valor: payload.modo_precificacao === 'sob_consulta' ? 'Sob Consulta' : 'Fixo em Créditos' 
    });
  }
  if (payload.creditos_padrao != null) {
    campos.push({ campo: 'Créditos Padrão', valor: String(payload.creditos_padrao) });
  }
  if (payload.valor_credito != null) {
    campos.push({ campo: 'Valor/Crédito', valor: formatarValorMonetario(payload.valor_credito) });
  }
  
  if (payload.modo_precificacao !== 'sob_consulta' && 
      payload.creditos_padrao != null && 
      payload.valor_credito != null) {
    const valorTotal = Number(payload.creditos_padrao) * Number(payload.valor_credito);
    campos.push({ campo: 'Valor Total', valor: formatarValorMonetario(valorTotal) });
  }

  return campos;
}

export default function ExpandedContentServicoAdicionado({ item, isExpanded }: ExpandedContentProps) {
  const payload = typeof item.payload === 'string' ? JSON.parse(item.payload || '{}') : (item.payload || {});

  // Formato agrupado: múltiplos serviços em um único log (criação de plano)
  if (payload?.servicos && Array.isArray(payload.servicos) && payload.servicos.length > 0) {
    const blocos = payload.servicos
      .map((s: any, idx: number) => {
        const campos = mapearDadosServicoAdicionado(s);
        if (campos.length === 0) return null;
        const nomeServico = formatServicoColuna(s.area_direito, s.servico, s.tipo_audiencia) || 'Serviço';
        return (
          <BlocoPrincipal
            key={idx}
            campos={campos}
            sectionTitle={nomeServico}
            tituloComoFaixa
          />
        );
      })
      .filter(Boolean);

    if (blocos.length === 0) {
      return (
        <ExpandedContent>
          <Separator />
          <EmptyState>Nenhum dado disponível.</EmptyState>
        </ExpandedContent>
      );
    }

    return (
      <ExpandedContent>
        <Separator />
        <h4 className="section-title">PRECIFICAÇÃO DE SERVIÇOS</h4>
        {blocos}
      </ExpandedContent>
    );
  }

  // Formato único serviço (retrocompatibilidade)
  const campos = mapearDadosServicoAdicionado(payload);

  if (campos.length === 0) {
    return (
      <ExpandedContent>
        <Separator />
        <EmptyState>Nenhum dado disponível.</EmptyState>
      </ExpandedContent>
    );
  }

  return (
    <ExpandedContent>
      <Separator />
      <BlocoPrincipal campos={campos} sectionTitle="PRECIFICAÇÃO DE SERVIÇOS" />
    </ExpandedContent>
  );
}
